// 📁 src/theme.js
import { createTheme } from '@mui/material/styles';

const theme = createTheme({
  palette: {
    primary: { main: '#1976d2' },   // Mavi vurgular
    secondary: { main: '#ffc107' }, // Sarı ton (istediğin eylemler için)
    error: { main: '#d32f2f' },     // Silme butonları için kırmızı
   // background: { paper: '#f5f5f5' }, // Kağıt benzeri arka plan
  },
  typography: {
    h5: { fontWeight: 600 },        // Başlıklarda daha kalın yazı
    button: { textTransform: 'none' }, // Butonlarda küçük harf korunur
  },
  components: {
    MuiButton: {
      styleOverrides: {
        root: {
          borderRadius: 8,          // Daha yuvarlak buton köşeleri
          padding: '6px 16px',
        }
      }
    },
    MuiIconButton: {
      styleOverrides: {
        root: {
          color: '#555',            // IconButton daha gri tonda
        }
      }
    },
    MuiMenu: {
      styleOverrides: {
        paper: {
          borderRadius: 8,
          marginTop: 8,
        }
      }
    },
    MuiTableCell: {
      styleOverrides: {
        head: {
          backgroundColor: '#e0e0e0', // Başlık hücrelerinde açık gri
          fontWeight: 600
        }
      }
    }
  }
});

export default theme;
